import Feeds from "./Feed";
import Info from "./Info";
import Media from "./Media";
import About from "./About";
export default {
  Info,
  Media,
  Feeds,
  About
};
